import { useMutation, useQuery } from "@apollo/react-hooks";
import { Card, Page } from "@shopify/polaris";
import React, { useCallback } from "react";
import { useParams } from "react-router-dom";

import { useAppContext } from "../../context";
import { UPDATE_AMAZON_IDEA_TEMPLATE } from "../../graphql/mutations/amazon-idea";
import { GET_AMAZON_IDEA_TEMPLATE } from "../../graphql/queries/amazon-idea";
import { getParamByRole, handleError } from "../../helper";
import history from "../../history";
import useTimeout from "../../hooks/useTimeout";
import SkeletonPagePolaris from "../shared/SkeletonPagePolaris";
import { useToastContext } from "../shared/ToastContext";
import AmazonIdeaTemplateForm from "./amazon-idea-template-form";

export default function UpdateAmazonIdeaTemplatePage() {
    const { id } = useParams();

    const { currentUser } = useAppContext();
    const pathname = getParamByRole(currentUser);
    const { setNotify, toggleToast } = useToastContext();

    const { data, loading, error } = useQuery(GET_AMAZON_IDEA_TEMPLATE, {
        variables: {
            id,
        },
        fetchPolicy: "no-cache",
    });

    const [setDelay] = useTimeout();
    const [updateAmazonIdeaTemplate, { loading: updateLoading }] = useMutation(
        UPDATE_AMAZON_IDEA_TEMPLATE,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Update amazon idea template successfully",
                    err: false,
                });
                setDelay(() => {
                    history.push(`/${pathname}/amazon-idea-templates`);
                }, 1000);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(
        (input) => {
            if (!input) return;

            setNotify && setNotify({ msg: null, err: false });
            toggleToast && toggleToast(true);
            updateAmazonIdeaTemplate({
                variables: {
                    input: { ...input, id },
                },
            });
        },
        [updateAmazonIdeaTemplate, setNotify, toggleToast, id],
    );

    return (
        <Page
            title="Update Amazon Idea Template"
            fullWidth
            breadcrumbs={[
                {
                    content: "Amazon Idea Templates",
                    url: `/${pathname}/amazon-idea-templates`,
                },
            ]}
        >
            <Card sectioned>
                {loading ? (
                    <SkeletonPagePolaris />
                ) : error ? (
                    <div>Error: {handleError(error?.toString())}</div>
                ) : (
                    <AmazonIdeaTemplateForm
                        value={data?.getAmazonIdeaTemplate}
                        onSubmit={handleSubmit}
                        loading={updateLoading}
                    />
                )}
            </Card>
        </Page>
    );
}
